import {create} from 'zustand';
 
export type PhysicalDeliveryStore = {
  deliveryRequests: any[];
  selectedAddress: any;
  selectedProduct: any;
  deliveryStatus: any;
  quotationSummary: any;
  setDeliveryRequests: (requests: any[]) => void;
  setSelectedAddress: (address: any) => void;
  setSelectedProduct: (product: any) => void;
  setDeliveryStatus: (status: any) => void;
  setQuotationSummary: (quotationSummary: any) => void;
  clearDeliveryData: () => void;
};
 
export const usePhysicalDeliveryStore = create<PhysicalDeliveryStore>((set) => ({
  deliveryRequests: [],
  selectedAddress: null,
  selectedProduct: null,
  deliveryStatus: null,
  quotationSummary: null,
 
  setDeliveryRequests: (requests) => set({ deliveryRequests: requests }),
  setSelectedAddress: (address) => set({ selectedAddress: address }),
  setSelectedProduct: (product) => set({ selectedProduct: product }),
  setDeliveryStatus: (status) => set({ deliveryStatus: status }),
  setQuotationSummary: (quotationSummary) => set({ quotationSummary }),
 
  clearDeliveryData: () =>
    set({ deliveryRequests: [], selectedAddress: null, selectedProduct: null, deliveryStatus: null, quotationSummary: null }),
}));
 